import { useEffect, useState } from "react"; 
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import authService from "../services/authService";
import Watermark from "./../components/Watermark";
import { Link } from "react-router-dom";

const ViewRegistration = () => {
  const [student, setStudent] = useState(null);
  const [downloadMode, setDownloadMode] = useState(false); // Track if PDF is being generated
  const signatureURL = "/sign1.png"; // Path to director's signature image

  useEffect(() => {
    const fetchStudentData = async () => {
      const user = authService.getCurrentUser();
      if (!user) return;

      try {
        const response = await axios.get("https://doshfebackend.teemah.com.ng/api/auth/profile/", {
          headers: { Authorization: `Bearer ${user.access}` },
        });

        const formattedData = { ...response.data };

        // Convert `true` values to "Yes"
        Object.keys(formattedData).forEach((key) => {
          if (formattedData[key] === true) {
            formattedData[key] = "Yes";
          }
        });

        // Format `class_schedule`
        if (formattedData.class_schedule) {
          formattedData.class_schedule += " time(s) per week.";
        }

        // Format `date_created` (Sunday, March 2, 2025 || 12:00 PM)
        if (formattedData.created_at) {
          const date = new Date(formattedData.created_at);
          const options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
          const formattedDate = date.toLocaleDateString("en-US", options);
          const formattedTime = date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
          formattedData.created_at = `${formattedDate} || ${formattedTime}`;
        }

        // Format `lecture_duration`
        if (formattedData.lecture_duration === "One_One_half") {
          formattedData.lecture_duration = "One to One and Half Hour";
        } else if (formattedData.lecture_duration === "One") {
          formattedData.lecture_duration = "One Hour";
        }

        setStudent(formattedData);
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    };

    fetchStudentData();
  }, []);

  const downloadPDF = () => {
    setDownloadMode(true); // Hide button before capturing screenshot

    setTimeout(() => {
      const element = document.getElementById("registration-container");

      html2canvas(element, { scale: 2, useCORS: true }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

        pdf.save("Student_Registration.pdf");

        setDownloadMode(false); // Show button again after download
      });
    }, 500);
  };

  return (
    <div className="min-h-screen bg-black p-4 flex flex-col items-center mt-20">
      <div className="my-4">
      <Link className="bg-red-600 text-white px-4 py-2 rounded-lg mb-4 hover:bg-red-700 transition p-4"to="/dashboard">
      Return To Dashboard</Link>
      </div>
      <div id="registration-container" className="relative w-full max-w-3xl bg-white shadow-lg rounded-lg p-6">
     
        <Watermark />
        <div className="relative flex justify-between items-center border-b pb-4 mb-4">
          <img src="/dca.png" alt="DCA" className="h-20" />
          <h2 className="text-2xl font-bold text-blue-600">Dosh Coding Academy</h2>
        </div>

        {student ? (
          <div>
            <div className="flex justify-end">
              {student.profile_picture && (
                <img
                  src={student.profile_picture}
                  alt="Profile"
                  className="w-32 h-32 object-cover border-4 border-blue-600"
                  crossOrigin="anonymous"
                />
              )}
            </div>

            <div className="grid grid-cols-2 gap-4">
              {Object.entries(student)
                .filter(([key]) => !["id", "completed", "is_approve", "profile_picture"].includes(key))
                .map(([key, value]) => (
                  <div key={key} className="border-b p-2 break-words">
                    <strong className="capitalize">{key.replace("_", " ")}:</strong> {String(value)}
                  </div>
                ))}
            </div>

            
           
            

            <div className="mt-10 flex justify-end">
  <div className="text-center">
    <img src={signatureURL} alt="Director Signature" className="h-24 mx-auto" />
    <p className="font-semibold">____________________________</p>
    <p className="font-semibold">Dosh Coding Academy Director</p>
    <em><p className="font-semibold text-blue-600">Oluwayemisi Oladosu</p></em>
  </div>
  <br />
            <br />
            <br />
            <br />
</div>



            {!downloadMode && ( // Hide button when downloading
              <button
                onClick={downloadPDF}
                className="w-full mt-4 p-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700"
              >
                Download as PDF
              </button>
            )}
          </div>
        ) : (
          <p className="text-center text-gray-600">Loading student data...</p>
        )}
      </div>
    </div>
  );
};

export default ViewRegistration;
